  <template>
  <div class="page updata">
    <van-cell-group>
      <van-field
        v-model="name"
        input-align="right"
        label="姓名"
        placeholder="请输入姓名"
        required
      ></van-field>
      <van-field
        v-model="age"
        input-align="right"
        label="性别"
        placeholder="请选择"
        required
        readonly
        @click="showage = !showage"
        right-icon="arrow"
      ></van-field>
      <van-field
        v-model="sex"
        input-align="right"
        label="体重"
        placeholder="请输入体重"
        required
      ></van-field>
      <van-field
        v-model="weight"
        input-align="right"
        label="年龄"
        placeholder="请输入年龄"
        required
      ></van-field>
      <van-field
        v-model="history"
        input-align="right"
        label="戴眼镜史"
        placeholder="请输入戴眼镜史"
        required
      ></van-field>
      <van-field
        v-model="phone"
        readonly="readonly"
        input-align="right"
        label="电话"
        placeholder="请输入电话"
        required
      ></van-field>
      <van-field
        v-model="site"
        input-align="right"
        label="地址"
        placeholder="请输入地址"
        required
      ></van-field>
      <van-field
        v-model="checkTime"
        input-align="right"
        readonly
        label="检查日期"
        placeholder="请选择日期"
        @click="show = !show"
        required
      ></van-field>
    </van-cell-group>
    <van-cell-group>
      <div class="item">
        <div class="item-title">裸眼视力</div>
        <van-field
          v-model="vcvaLeft"
          label="左眼"
          placeholder="请输入"
        ></van-field>
        <van-field
          v-model="vcvaRight"
          label="右眼"
          placeholder="请输入"
        ></van-field>
      </div>
      <div class="item">
        <div class="item-title">矫正视力</div>
        <van-field
          v-model="cvaLeft"
          label="左眼"
          placeholder="请输入"
        ></van-field>
        <van-field
          v-model="cvaRight"
          label="右眼"
          placeholder="请输入"
        ></van-field>
      </div>
      <div class="item">
        <div class="item-title">电脑验光</div>
        <van-field
          v-model="optometryLeft"
          label="左眼"
          placeholder="请输入"
        ></van-field>
        <van-field
          v-model="optometryRight"
          label="右眼"
          placeholder="请输入"
        ></van-field>
      </div>
      <div class="item">
        <div class="item-title">眼压</div>
        <van-field
          v-model="iopLeft"
          label="左眼"
          placeholder="请输入"
        ></van-field>
        <van-field
          v-model="iopRight"
          label="右眼"
          placeholder="请输入"
        ></van-field>
      </div>
      <div class="item">
        <div class="item-title">眼轴长度</div>
        <van-field
          v-model="axialLengthLeft"
          label="左眼"
          placeholder="请输入"
        ></van-field>
        <van-field
          v-model="axialLengthRight"
          label="右眼"
          placeholder="请输入"
        ></van-field>
      </div>
      <div class="item">
        <div class="item-title">角膜曲率</div>
        <van-field
          v-model="cornealCurvatureLeft"
          label="左眼"
          placeholder="请输入"
        ></van-field>
        <van-field
          v-model="cornealCurvatureRight"
          label="右眼"
          placeholder="请输入"
        ></van-field>
      </div>
      <div class="item">
        <div class="item-title">角膜厚度</div>
        <van-field
          v-model="cornealThicknessLeft"
          label="左眼"
          placeholder="请输入"
        ></van-field>
        <van-field
          v-model="cornealThicknessRight"
          label="右眼"
          placeholder="请输入"
        ></van-field>
      </div>
      <div class="item">
        <div class="item-title">前房深度</div>
        <van-field
          v-model="chamberDepthLeft"
          label="左眼"
          placeholder="请输入"
        ></van-field>
        <van-field
          v-model="chamberDepthRight"
          label="右眼"
          placeholder="请输入"
        ></van-field>
      </div>
      <div class="item">
        <div class="item-title">晶体厚度</div>
        <van-field
          v-model="crystalThicknessLeft"
          label="左眼"
          placeholder="请输入"
        ></van-field>
        <van-field
          v-model="crystalThicknessRight"
          label="右眼"
          placeholder="请输入"
        ></van-field>
      </div>
      <div class="item">
        <div class="item-title">玻璃体厚度</div>
        <van-field
          v-model="vitreousThicknessLeft"
          label="左眼"
          placeholder="请输入"
        ></van-field>
        <van-field
          v-model="vitreousThicknessRight"
          label="右眼"
          placeholder="请输入"
        ></van-field>
      </div>
      <div class="item">
        <div class="item-title">脉络膜厚度</div>
        <van-field
          v-model="choroidalThicknessLeft"
          label="左眼"
          placeholder="请输入"
        ></van-field>
        <van-field
          v-model="choroidalThicknessRight"
          label="右眼"
          placeholder="请输入"
        ></van-field>
      </div>
    </van-cell-group>
    <van-cell-group>
      <van-field name="uploader" label="视力情况图片">
        <template #input>
          <van-uploader :after-read="afterRead" v-model="photoList" :before-delete="deleteImg"/>
        </template>
      </van-field>
    </van-cell-group>
    <div class="foot">
      <van-button type="primary" block @click="updata" round>上传</van-button>
    </div>

    <van-popup v-model="showage" position="bottom">
       <van-cell title="男" @click="age = '男';showage = false"/>
       <van-cell title="女" @click="age = '女';showage = false"/>
       <van-cell title="取消" @click="showage = false"/>
    </van-popup>
    <van-popup v-model="show" position="bottom">
      <van-datetime-picker
        v-model="currentDate"
        type="date"
        @confirm="setData"
        title="选择年月日"
        :max-date="maxDate"
      />
    </van-popup>
  </div>
</template>

<script>
import API from "../utils/api";

export default {
  data() {
    return {
      currentDate: new Date(),
      maxDate: new Date(),
      show: false,
      showage: false,
      icCard: "",
      name: "",
      age: "",
      sex: "kg",
      weight: "",
      history: "",
      phone: "",
      site: "",
      checkTime: "",
      vcvaLeft: "",
      vcvaRight: "",
      cvaLeft: "",
      cvaRight: "",
      optometryLeft: "",
      optometryRight: "",
      iopLeft: "",
      iopRight: "",
      axialLengthLeft: "",
      axialLengthRight: "",
      cornealCurvatureLeft: "",
      cornealCurvatureRight: "",
      cornealThicknessLeft: "",
      cornealThicknessRight: "",
      chamberDepthLeft: "",
      chamberDepthRight: "",
      crystalThicknessLeft: "",
      crystalThicknessRight: "",
      vitreousThicknessLeft: "",
      vitreousThicknessRight: "",
      choroidalThicknessLeft: "",
      choroidalThicknessRight: "",
      photoList: [],
      imgList: []
    };
  },
  watch: {},
  computed: {},
  methods: {
    updata() {
      console.log(this.imgList);
      let parmas = {
        icCard: sessionStorage.getItem("card"),
        name: this.name,
        age: this.age,
        sex: this.sex,
        weight: this.weight,
        history: this.history,
        phone: this.phone,
        site: this.site,
        checkTime: this.checkTime,
        vcvaLeft: this.vcvaLeft,
        vcvaRight: this.vcvaRight,
        cvaLeft: this.cvaLeft,
        cvaRight: this.cvaRight,
        optometryLeft: this.optometryLeft,
        optometryRight: this.optometryRight,
        iopLeft: this.iopLeft,
        iopRight: this.iopRight,
        axialLengthLeft: this.axialLengthLeft,
        axialLengthRight: this.axialLengthRight,
        cornealCurvatureLeft: this.cornealCurvatureLeft,
        cornealCurvatureRight: this.cornealCurvatureRight,
        cornealThicknessLeft: this.cornealThicknessLeft,
        cornealThicknessRight: this.cornealThicknessRight,
        chamberDepthLeft: this.chamberDepthLeft,
        chamberDepthRight: this.chamberDepthRight,
        crystalThicknessLeft: this.crystalThicknessLeft,
        crystalThicknessRight: this.crystalThicknessRight,
        vitreousThicknessLeft: this.vitreousThicknessLeft,
        vitreousThicknessRight: this.vitreousThicknessRight,
        choroidalThicknessLeft: this.choroidalThicknessLeft,
        choroidalThicknessRight: this.choroidalThicknessRight,
        photoList: this.imgList.join(","),
      };
      this.$post(`${API.info}`, parmas)
        .then((res) => {
          if (res.code == 200) {
            this.$toast("提交成功")
            this.$router.push({ path: `index` });
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    deleteImg(file,detail){
      this.imgList.splice(detail.index, 1)
      console.log(this.imgList)
      return true
    },
    afterRead(file) {
      let formdata = new FormData();
      formdata.append("file", file.file);
      this.$post(`/dev-api/common/upload`, formdata)
        .then((res) => {
          if (res.code == 200) {
            this.imgList.push(res.url)
            console.log(this.imgList)
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    setData(val){
      console.log(new Date(val).toLocaleDateString())
      this.checkTime = new Date(val).toLocaleDateString().split("/").join("-")
      this.show = false
    }
  },
  created() {
    this.phone = sessionStorage.getItem("phone")
  },
  mounted() {},
};
</script>
<style>
.updata .item {
  display: flex;
}
.updata .item .item-title {
  width: 260px;
  padding: 10px 0 10px 16px;
  line-height: 24px;
}
.updata .item .van-cell__title {
  width: 3em;
}
.updata .item .van-cell::after {
  border: none;
}
.van-popup .van-cell{
  text-align: center;
}
.foot{
  padding: 20px;
}
.van-button{
  background-color: #85e5d0;
  border: 0.026667rem solid #85e5d0;
}
</style>


// WEBPACK FOOTER //
// src/pages/updata.vue